<template>
    <div class="app">
        <ul class="user-list">
            <li @click="selectVoucher()">
               <span>选择就诊人</span>
            </li>
            <li>
                <input id="voucherAdd-input-userName" type="text" class="form-right gwi-ipt my-ipt"
                    v-model="userName" placeholder="请输入姓名" maxlength="20">
            </li>
            <li>
                <input id="voucherAdd-input-cardNo" type="text" class="form-right gwi-ipt my-ipt"
                    v-model="cardNo" placeholder="请输入就诊人身份证号码" maxlength="20">
            </li>
            <li>
                <input id="voucherAdd-input-userPhoneNo" type="text" class="form-right gwi-ipt my-ipt"
                    v-model="userPhoneNo" placeholder="请输入手机号码" maxlength="11">
            </li>
        </ul>
        <div class="ok-wrap">
           <button id="feedback-submit" class="btn-ok" type="button" @click="submit()">确认</button>
        </div>
        <half-window v-model="showWindow" :data-list="voucherList">
            <span slot="title"><span class="f-strong">选择就诊人</span></span>
            <ul slot="list" class="list">
                <li v-for="item in voucherList" class="list-item" :class="'arr-item-blue'"
                    @click="selectUser(item)">
                    <span>{{item.holderName}}/{{item.cardNo | dotted}}</span>
                </li>
            </ul>
        </half-window>
    </div>
</template>

<script>
    import utils from 'utils'
    import HalfWindow from 'HalfWindow'
    import queryVoucher from 'voucher.service'
    const checkForm = function (data) {
        if (data.userName === null || data.userName.trim().length === 0) {
            return '输入姓名不能为空';
        }
        if (data.cardNo.length === 0) {
            return '身份证号不能为空';
        }

        //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
        if (data.cardNo === null || !(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(data.cardNo.toUpperCase()))) {
            return '身份证号输入有误';
        }
        if (data.userPhoneNo.length === 0) {
            return '手机号不能为空'
        } else if (!/^1[3456789]\d{9}$/.test(data.userPhoneNo)) {
            return '您输入的手机号码错误，请重新入'
        }

    }
    export default{
        components:{
            HalfWindow
        },
        data() {
            return{
                voucherList:[],
                userName:'',
                cardNo:'',
                userPhoneNo:'',
                showWindow:false,
                hosUrl:''
            }
        },
        mounted() {

        },
        methods: {
            loadVoucher() {
                this.voucherList = []
                // 获取用户就诊凭证
                queryVoucher.getVoucherList().then((res) => {
                    if (res.resultCode !== this.constant.RESULT_SUCCESS) {
                        this.$utils.alert(res.resultMsg);
                        return;
                    }
                    this.voucherList = res.data ? res.data : [];
                    this.showWindow = true;
                });
            },
            selectVoucher() {
                this.loadVoucher()
            },
            selectUser(item) {
                this.userName = item.holderName
                this.cardNo = item.cardNo
                this.phone = item.mobileNo
            },
            submit() {
                let errorMsg = checkForm(this);
                if (errorMsg) {
                    return utils.alert(errorMsg);
                }
                let url = this.$store.state.paramModule.param.Hospital.query.selectedHospital.jumpAddr
                let userName = encodeURI(this.userName)
                //访问链接地址,后台会带部分参数过来
                this.hosUrl = `${url}&patientname=${userName}&patientidcardno=${this.cardNo}&patienttelephone=${this.userPhoneNo}`
                this.$store.commit('updateParam', {
                    namespace: 'Hospital',
                    queryUrl: this.hosUrl
                })
                this.$router.replace({
                    name: 'HospitalPage',
                    query: this.hosUrl
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.app {
    background-color: #EEF2F5;
    padding-bottom: 3.75rem;
    .user-list {
        li {
            height: 2.25rem;
            line-height: 2.25rem;
            padding: 0 0.5rem;
            display: flex;
            justify-content: space-between;
            border-bottom: 0.025rem solid #EEF2F5;
            background-color: #fff;
            overflow: hidden;
            &:before {
                position: absolute;
                content: '';
                height: 0.7rem;
                width: 0.4rem;
                top:0.7rem;
                right:0.55rem;
                background-image: url(../../../static/img/more-arrow.png);
                background-size: 100% 100%;
            }
        }
    }
    .ok-wrap{
        padding:0 0.5rem;
        margin-top: 0.5rem;
        .btn-ok {
           letter-spacing:1px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// HealthySichuanRegister.vue?6456e596